module.exports = __webpack_public_path__ + "img/depthMap-bermagui240.62969d5a.png";